let styles = {
    container: {
        textAlign: 'center',
        width: '90%',
        margin: 'auto',
    },
    title: {
        fontSize: '25px',
        fontWeight: 'bolder',
        textAlign: 'left',
        marginTop: '30px',
        marginBottom: '20px',
        color:'#fff',
    },
    gridList: {
        width: '100%',
        overflowY: 'auto',
        margin: 0,
        marginTop: '5px'
    },
    align: {
        verticalAlign: 'middle'
    },
    favItem: {
        display: 'inline-block',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        width: 'calc(100%)',
        height: '150px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
    },
    overlay: {
        padding: '10px',
        color: '#fff',
        //background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)',
        background: 'rgba(0,0,0,0.25)',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
        textAlign: 'left',
    },
    name: {
        display: 'inline-block',
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: '100%',
        transform: 'translate(-50%,-50%)',
        textAlign: 'center',
        fontSize: '20px',
        textTransform: 'uppercase',
        fontWeight: 'bold'
    }
};
export default styles;